/**
 * The pieces per unit an order line recorded at placement (Orders 6), or
 * undefined when it is unknown. Two order reads carry it: the admin order
 * detail (`AdminOrderProduct.piecesPerUnit`) and the customer order
 * confirmation (`OrderProductResponse.piecesPerUnit`). Unknown is 0 (a line
 * the app placed before API PR 435 deployed, between the migration and the
 * deploy) or absent (an API from before that read carried the field).
 * Undefined, never 0, so no caller divides by it or shows "0" as a real count.
 */
export const recordedPiecesPerUnit = (
    recorded: number | undefined,
): number | undefined =>
    recorded !== undefined && recorded > 0 ? recorded : undefined;
